/**
 * What the board's two scroll containers do while a card is being dragged.
 *
 * They share a strength so the board and a cell inside it move at the same rate, which
 * is what makes a drag that crosses from one into the other feel like one gesture.
 */

/** Pixels per animation frame at full velocity, matching the reference board. */
export const AUTO_SCROLL_STRENGTH = 50

/**
 * Half the board's width is a dead zone. A board is wide and shallow, so a pointer
 * anywhere near the middle of it is not asking to go sideways.
 */
export const HORIZONTAL_DEAD_ZONE_RATIO = 0.5

/** The same reasoning down a cell, which is tall and narrow. */
export const VERTICAL_DEAD_ZONE_RATIO = 0.5

/**
 * The band at the board's own top and bottom edge inside which a drag scrolls the board
 * downwards, to reach a swimlane that is off screen.
 *
 * A fixed depth rather than a fraction of the board, and a shallow one, because this band
 * overlaps the cells it is drawn over. A cell at the edge of the board is usually clipped
 * by it, so the cell's own band is off screen and only this one is left, but where a cell
 * ends exactly at the board's edge both are in reach and both scroll. Keeping this to the
 * last stretch of the board is what makes that rare rather than the normal case.
 *
 * It does nothing on a board with no swimlanes: one row is the whole scrollport, so the
 * board does not overflow downwards and `useAutoScroll` measures no velocity for an axis
 * with no travel.
 */
export const ROOT_VERTICAL_BAND: readonly [number, number] = [64, 64]
